import { render, staticRenderFns } from "./CreateKirmiziSantralChannel.vue?vue&type=template&id=1e69043b&scoped=true"
import script from "./CreateKirmiziSantralChannel.vue?vue&type=script&lang=js"
export * from "./CreateKirmiziSantralChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateKirmiziSantralChannel.vue?vue&type=style&index=0&id=1e69043b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e69043b",
  null
  
)

export default component.exports